import { SimpleTableTWProps } from './SimpleTableTW';
import { flexRender } from '@tanstack/react-table';
import React from 'react';

export function SimpleTableBody<T>({ table }: SimpleTableTWProps<T>) {
  return (
    <tbody className={'divide-y divide-gray-300 bg-white'}>
      {table.getRowModel().rows.map((row) => (
        <tr key={row.id}>
          {row.getVisibleCells().map((cell) => (
            <td style={{ width: cell.column.getSize() ? cell.column.getSize() : 'auto' }} key={cell.id} className={'whitespace-pre-line py-4 px-6 text-sm font-medium text-gray-900 '}>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
